var map = {
	"./arrow-circled.svg": 812,
	"./arrow.svg": 813,
	"./cell-phone.svg": 814,
	"./chat.svg": 815,
	"./check-circle.svg": 816,
	"./check-icon.svg": 817,
	"./clock.svg": 818,
	"./contract.svg": 819,
	"./cross.svg": 820,
	"./download.svg": 821,
	"./dropdownArrow.svg": 822,
	"./edit.svg": 823,
	"./error.svg": 824,
	"./error_cat.svg": 825,
	"./globe.svg": 826,
	"./gosLogo.svg": 827,
	"./gps.svg": 828,
	"./home.svg": 829,
	"./infinity-dark.svg": 830,
	"./infinity.svg": 831,
	"./info.svg": 832,
	"./letter.svg": 833,
	"./messages.svg": 834,
	"./newarrow.svg": 835,
	"./pdf.svg": 836,
	"./pen.svg": 837,
	"./phone.svg": 838,
	"./phoneDetail.svg": 839,
	"./refresh.svg": 840,
	"./reload.svg": 841,
	"./settings.svg": 842,
	"./sharing.svg": 843,
	"./smartphone.svg": 844,
	"./smile-dead.svg": 845,
	"./star.svg": 846,
	"./statusOk.svg": 847,
	"./xls.svg": 848,
	"./xlsx.svg": 849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;